<template>
    <select
      class="xc-select"
      v-model="picker"
      @change="change"
    >
      <option value="">{{placeholder || tips}}</option>
      <option
        v-for="(item,index) in data"
        :key="index"
      >{{item.label}}</option>
    </select>
</template>

<script>
import provinceData from './data/province.js';
import cityData from './data/city.js';
import areaData from './data/area.js';

export default {
  name: 'XcCityPicker',
  props: {
    type: {
      type: String,
      default: 'province',
    },
    value: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      picker: '',
      tips: '',
    }
  },
  methods: {
    change() {
      let value = this.value;

      switch (this.type) {
        case 'province':
          value = [this.picker, '', ''];
          break;
        case 'city':
          value = [value[0], this.picker, '']
          break;
        case 'area':
          value = [value[0], value[1], this.picker];
          break;
        default:
          break;
      }

      this.$emit('update:value', value);
    },
    // 获取所选数据对应index
    getDataIndex(value, data) {
      if (value != undefined && value != '') {
        for (let i = 0; i < data.length; i++) {
          const item = data[i];
          if (item.label == value) {
            return i;
          }
        }
      }
    },
    // 初始化数据
    init() {
      switch (this.type) {
        case 'province':
          if (!this.picker && this.value[0]) this.picker = this.value[0];
          if (!this.placeholder) this.tips = '请选择省份';
          break;
        case 'city':
          if (!this.picker && this.value[1]) this.picker = this.value[1];
          if (!this.placeholder) this.tips = '请选择城市';
          break;
        case 'area':
          if (!this.picker && this.value[2]) this.picker = this.value[2];
          if (!this.placeholder) this.tips = '请选择区县';
          break;
        default:
          break;
      }
    }
  },
  created() {
    this.init();
  },
  watch: {
    value(value) {
      switch (this.type) {
        case 'province':
          this.picker = value[0];
          break;
        case 'city':
          this.picker = value[1];
          break;
        case 'area':
          this.picker = value[2];
          break;
        default:
          break;
      }
    }
  },
  computed: {
    provinceIndex() {
      return this.getDataIndex(this.value[0], provinceData);
    },
    cityIndex() {
      return this.getDataIndex(this.value[1], cityData[this.provinceIndex]);
    },
    data() {
      if (this.type == 'province') {
        return provinceData;
      }else if (this.type == 'city' && this.provinceIndex != undefined) {
        return cityData[this.provinceIndex];
      }else if (this.type == 'area' && this.cityIndex != undefined) {
        return areaData[this.provinceIndex][this.cityIndex]
      }

      return [];
    }
  }
}
</script>

<style scoped>
</style>
